export default __webpack_public_path__ + "static/media/sidebar_accessories_blue.e636c469.svg";